// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactDom from "react-dom";
import * as Dots$ReasonReactWebsite from "./Dots.bs.js";
import * as PolkaBlock$ReasonReactWebsite from "./PolkaBlock.bs.js";

var root = document.querySelector("#root");

if (!(root == null)) {
  ReactDom.render(React.createElement("div", undefined, React.createElement("div", {
                id: "dots"
              }), React.createElement(PolkaBlock$ReasonReactWebsite.make, {})), root);
}

Dots$ReasonReactWebsite.makeDots(200, document.getElementById("dots"));

export {
  
}
/* root Not a pure module */
